/* eslint-disable no-unsafe-optional-chaining */
/* eslint-disable unicorn/no-zero-fractions */
/* eslint-disable unicorn/numeric-separators-style */
import { Flex } from '@chakra-ui/react';
import { ReactGrid } from '@silevis/reactgrid';
import { useEffect, useMemo, useRef, useState } from 'react';

import { CHART_COLORS } from 'projectConstants';
// import { reorderArray } from 'pages/PlannerMode/TableHelpers';

// import { AddRow } from './AddRow';
import { DeleteRow } from './DeleteRow';
import { HeaderRow } from './HeaderRow';
import './Table.scss';
import { TextCellTemplate } from './TextCellTemplate';

// const ExData = {
//   id: 173919,
//   type: 'constant_by_year',
//   dimensions: [
//     {
//       id: '27234',
//       position: 2,
//     },
//     {
//       id: '27235',
//       position: 1,
//     },
//   ],
//   scenario_id: 12853,
//   data_values: [
//     {
//       '27234': 'A',
//       '27235': 'Z',
//       value: 3.0,
//       '27233': '2024',
//     },
//     {
//       '27234': 'A',
//       '27235': 'Z',
//       value: 4.0,
//       '27233': '2024',
//     },
//     {
//       '27234': 'A',
//       '27235': 'Y',
//       value: 2.0,
//       '27233': '2025',
//     },
//     {
//       '27234': 'B',
//       '27235': 'Y',
//       value: 5.0,
//       '27233': '2025',
//     },
//     {
//       '27234': 'A',
//       '27235': 'Y',
//       value: 1.0,
//       '27233': '2024',
//     },
//     {
//       '27234': 'A',
//       '27235': 'Z',
//       value: 3.0,
//       '27233': '2025',
//     },
//     {
//       '27234': 'A',
//       '27235': 'Z',
//       value: 4.0,
//       '27233': '2025',
//     },
//     {
//       '27234': 'A',
//       '27235': 'Y',
//       value: 2.0,
//       '27233': '2024',
//     },
//     {
//       '27234': 'B',
//       '27235': 'Y',
//       value: 5.0,
//       '27233': '2024',
//     },
//     {
//       '27234': 'A',
//       '27235': 'Y',
//       value: 1.0,
//       '27233': '2025',
//     },
//   ],
//   indicator_id: 163455,
//   date_created: '2024-01-02',
//   excel_data: {
//     columns: ['_27235', '_27234', '2024', '2025'],
//     index: [
//       ['A', 'A', 'B', 'B'],
//       ['Y', 'Y', 'Z', 'Z'],
//     ],
//     data: [
//       [1.0, 2.0],
//       [5.0, 5.0],
//       [3.0, 3.0],
//       [0.0, 0.0],
//     ],
//   },
//   dimension_map: [
//     {
//       id: 27234,
//       name: 'd1',
//       map: '_27234',
//     },
//     {
//       id: 27235,
//       name: 'd2',
//       map: '_27235',
//     },
//   ],
// };

const tableDataType = [
  {
    '27235': { value: 'Basic', id: 'x1' },
    '27234': { value: 'UK', id: 'x2' },
    '27236': { value: 'London', id: 'x9' },
    '2024': '1',
    '2025': '2',
    '2026': '3',
    id: '1',
  },
  {
    '27235': { value: 'Basic', id: 'x1' },
    '27234': { value: 'UK', id: 'x2' },
    '27236': { value: 'XB', id: 'x10' },
    '2024': '4',
    '2025': '5',
    '2026': '6',
    id: '2',
  },
  {
    '27235': { value: 'Basic', id: 'x1' },
    '27234': { value: 'India', id: 'x5' },
    '27236': { value: 'London', id: 'x9' },
    '2024': '7',
    '2025': '8',
    '2026': '9',
    id: '3',
  },
  {
    '27235': { value: 'Basic', id: 'x1' },
    '27234': { value: 'India', id: 'x5' },
    '27236': { value: 'XY', id: 'x11' },
    '2024': '10',
    '2025': '11',
    '2026': '12',
    id: '4',
  },
  {
    '27235': { value: 'Premium', id: 'x3' },
    '27234': { value: 'UK', id: 'x2' },
    '27236': { value: 'London', id: 'x9' },
    '2024': '13',
    '2025': '14',
    '2026': '15',
    id: '5',
  },
  {
    '27235': { value: 'Premium', id: 'x3' },
    '27234': { value: 'UK', id: 'x2' },
    '27236': { value: 'XQ', id: 'x12' },
    '2024': '16',
    '2025': '17',
    '2026': '18',
    id: '6',
  },
  {
    '27235': { value: 'Premium', id: 'x3' },
    '27234': { value: 'India', id: 'x5' },
    '27236': { value: 'London', id: 'x9' },
    '2024': '19',
    '2025': '20',
    '2026': '21',
    id: '7',
  },
  {
    '27235': { value: 'Premium', id: 'x3' },
    '27234': { value: 'India', id: 'x5' },
    '27236': { value: 'XZ', id: 'x14' },
    '2024': '22',
    '2025': '23',
    '2026': '24',
    id: '8',
    position: 4,
  },
];

// const tableColumn = [
//   {
//     id: '27235',
//     name: 'd1',
//     type: 'dimension',
//     data_format: '',
//   },
//   {
//     id: '27234',
//     name: 'd2',
//     type: 'dimension',
//     data_format: '',
//   },
//   {
//     id: '27236',
//     name: 'd2',
//     type: 'dimension',
//     data_format: '',
//   },
//   {
//     id: '2024',
//     name: 'Time',
//     type: 'time',
//   },
//   {
//     id: '13443',
//     name: '2025',
//     type: 'time',
//     data_format: '',
//   },
// ];

const tableColumn = [
  {
    id: '27235',
    name: 'd1',
    type: 'dimension',
  },
  {
    id: '27234',
    name: 'd2',
    type: 'dimension',
  },
  {
    id: '27236',
    name: 'd3',
    type: 'dimension',
  },
  {
    id: '13442',
    name: '2024',
    type: 'time',
  },
  {
    id: '13442',
    name: '2025',
    type: 'time',
  },
  {
    id: '13442',
    name: '2026',
    type: 'time',
  },
];

const headerRow = (tableProperty_: any) => ({
  rowId: 'header',
  height: 40,
  cells: [
    ...(tableProperty_?.length
      ? tableProperty_?.map((data: any, index: any) => {
          const row = {
            type: 'header',
            colType: 'header',
            nonEditable: true,
            property: data?.type,
            id: data?.id,
            text: data?.name,
            className: `header-cell ${index === tableProperty_?.length - 1 ? ' last-index ' : ''}`,
            data,
          };
          return row;
        })
      : []),
    // {
    //   type: 'header',
    //   property: 'Del',
    //   text: 'Del',
    //   nonEditable: true,
    //   colType: 'header',
    //   className: 'header-cell header-last',
    // },
  ],
});

const getRows = (tableItemsProperty_: any, tableProperty_: any) => {
  return [
    headerRow(tableProperty_),
    ...(tableItemsProperty_?.length
      ? tableItemsProperty_?.map((item: any, index: any) => {
          return {
            rowId: item?.id,
            height: 40,
            // itemName: item?.name,
            reorderable: true,
            // isNewCell: !!item?.isNewCell,
            cells: [
              ...(tableProperty_?.length
                ? tableProperty_?.map((data: any, index_: any) => {
                    const fData = data?.type === 'dimension' ? item[data.id] : item[data?.name];
                    const row = {
                      rowId: data?.id,
                      type: 'text',
                      // name: data?.type === 'dimension' ? data?.id : data?.name,
                      property: data?.type,
                      uniqueId: fData?.uniqueid,
                      show: true,
                      color: CHART_COLORS[fData?.uniqueid],
                      rows: tableItemsProperty_?.length,
                      itemmId: data?.type === 'dimension' ? `${fData?.id}` : `${data?.id}`,
                      text: data?.type === 'dimension' ? `${fData?.value}` : `${fData}` ?? '',
                      index,
                      data,
                      nonEditable: !item?.id && !item?.indicatorId,
                      className: `${index_ === tableProperty_?.length - 1 ? ' last-index ' : ''} ${
                        item?.warning?.length > 0 ? 'formula-error ' : ''
                      }`,
                    };
                    return row;
                  })
                : []),
            ],
          };
        })
      : []),
  ];
};

const calculateWidth = (totalElements: number, totalWidth: number) => {
  const nameField: number = 150;
  const editField: number = 60;
  const columnsWidth = totalElements * 150 + nameField + editField;
  return totalWidth > columnsWidth ? (totalWidth - editField) / (totalElements + 1) : 150;
};

const getColumns = (tableProperty_: any, tableReference: any) => {
  const columnWidth =
    tableProperty_ || tableReference ? calculateWidth(tableProperty_?.length, tableReference) : 200;
  return [
    ...(tableProperty_?.length
      ? tableProperty_?.map((data: any) => {
          const row = {
            columnId: data?.type === 'dimension' ? `${data?.id}` : `${data?.name}`,
            name: data?.name,
            width: columnWidth,
            resizable: true,
            reorderable: true,
          };
          return row;
        })
      : []),
    { columnId: 'delete', width: 60 },
  ];
};
const handleColumnResize = (ci: any, width: any, setColumns: any) => {
  setColumns((column: any) => {
    const columnIndex = column.findIndex((element: any) => element.columnId === ci);
    const resizedColumn = column[columnIndex];
    const updatedColumn = { ...resizedColumn, width };
    column[columnIndex] = updatedColumn;
    return [...column];
  });
};

const reorderArray = (array: any, idxs: number[], to: number) => {
  const movedElements = array.filter((_: any, index: any) => idxs.includes(index));
  const targetIndex =
    Math.min(...idxs) < to ? (to += 1) : (to -= idxs.filter((index) => index < to).length);
  const leftSide = array.filter(
    (_: any, index: any) => index < targetIndex && !idxs.includes(index),
  );
  const rightSide = array.filter(
    (_: any, index: any) => index >= targetIndex && !idxs.includes(index),
  );
  return [...leftSide, ...movedElements, ...rightSide];
};

const MultiDimensionTable = () => {
  const tableReference: any = useRef(null);

  const memorizedColumns = useMemo(() => {
    return tableColumn?.length >= 0 && getColumns(tableColumn, tableReference.current?.offsetWidth);
  }, [tableColumn]);
  const [columns, setColumns]: any = useState(memorizedColumns);

  const rows: any = useMemo(() => {
    const uniqueIds: any = {};
    let counter = 0;
    const myFirstId: any = tableColumn[0]?.id;
    const newArray = tableDataType.map((element: any) => {
      if (uniqueIds[element[myFirstId].id] === undefined) {
        uniqueIds[element[myFirstId].id] = counter;
        element[myFirstId].uniqueid = counter;
        counter += 1;
      } else {
        element[myFirstId].uniqueid = uniqueIds[element[myFirstId].id];
      }
      return element;
    });
    return getRows(newArray, tableColumn);
  }, [tableColumn, tableDataType]);

  useEffect(() => {
    setColumns(memorizedColumns);
  }, [memorizedColumns]);

  // const handleAddRow = () => {};

  const handleColumnsReorder = (targetColumnId: any, columnIds: any) => {
    const to = columns.findIndex(
      (column: any) => Number(column.columnId) === Number(targetColumnId),
    );
    const columnIdxs = columnIds.map((columnId: any) =>
      columns.findIndex((c: any) => c.columnId === columnId),
    );
    setColumns((previousColumns: any) => reorderArray(previousColumns, columnIdxs, to));
  };
  return (
    <Flex ref={tableReference} className='block-table-container sm-scroll'>
      <ReactGrid
        rows={rows}
        columns={columns}
        onColumnResized={(ci, width) => handleColumnResize(ci, width, setColumns)}
        onColumnsReordered={handleColumnsReorder}
        enableColumnSelection
        customCellTemplates={{
          header: new HeaderRow(),
          delete: new DeleteRow(),
          text: new TextCellTemplate(),
          // addRow: new AddRow(handleAddRow, planPermission),
        }}
      />
    </Flex>
  );
};

export default MultiDimensionTable;
